module.exports = __webpack_public_path__ + "triangles.1f60c768.webp";